import React from "react";

import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import BcaIconButton from "../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import VirtualOrderModal from "../../../../VirtualPortfolioManager/modals/VirtualOrderModal";
import {getInitVPTransactions} from "../../../../Modelportfolios/utils";
import {PortfolioHandlerResource} from "../../../../../utils/api";


const MusterDepotOrderButton = (props) => {
  const {portfolio, dispatch, refresh, paymentPlan} = props;

  const [open, setOpen] = React.useState(false);
  const [portfoliosTransactions, setPortfoliosTransactions] = React.useState([]);

  const emptyData = {data: []};
  const isTrading = paymentPlan === undefined;

  const initPortfoliosTransactions = () => {
    setPortfoliosTransactions(getInitVPTransactions(
      {data: [portfolio]},  // we should always set instruments
      emptyData,
      !isTrading ? {data: [paymentPlan]} : emptyData,
      isTrading
    ))
  };

  React.useEffect(() => {
    initPortfoliosTransactions()
  }, []);

  return (
    <>
      <BcaIconButton
        tooltip={"Neue Transaktionen simulieren"}
        icon={<i className="fal fa-shopping-cart" />}
        onClick={() => setOpen(true)}
      />
      <VirtualOrderModal
        open={open}
        onClose={() => {setOpen(false)}}
        resource={PortfolioHandlerResource}
        portfoliosTransactions={portfoliosTransactions}
        setPortfoliosTransactions={setPortfoliosTransactions}
        initPortfoliosTransactions={initPortfoliosTransactions}

        portfolioOwnerId={props.match.params.customer_id}
        isCustomerApp
        refresh={refresh}
        dispatch={dispatch}
      />
    </>
  )
};

export default withRouter(connect()(MusterDepotOrderButton));